//axios实例封装
import axios from "axios";
//引入elementul的弹框提醒组件后面要用来报错
import { Toast } from 'vant';

import router from '../main'

const service = axios.create({
    //基础路径URL配置
    // baseURL: "http://localhost:8888",
    baseURL: "https://select.user.nanjingtianma.top",
})


//请求拦截
service.interceptors.request.use(config => {
    config.headers['Authorization'] = sessionStorage.getItem('token') // 请求头带上token，一般后端的请求都要带上token才能成功的，没有token会被判断未登录，这里根据个人不同改获取token的方式。不需要的直接删掉这行代码就行，其他不动
    return config
}, error => {
    console.log("====");
    return Promise.reject(error)
})


//响应拦截器
service.interceptors.response.use((response) => {
    //只返回config内的data的数据，其他的不展示
    const res = response.data
    if (res.code != 200) {
        if (res.code == 401) {
            Toast("登录超时！");
            setTimeout(() => {
                router.push({ name: 'AdminUser' });
            }, 2000)
        }else{
            Toast(res.msg);
        }
    }
    return res
}, (error) => {
    //如果请求出错会有弹框提示
    Toast(error.message);
    return Promise.reject(error)
})

export default service
